import React from "react";
import AppIcon from "../../../components/ui/AppIcon";

export default function MobileBottomNav({ activeView = "chat", onViewChange, onSearchOpen }) {
    const navItems = [
        { id: "chat",     label: "Chats",    icon: "ChatBubbleLeftRightIcon" },
        { id: "channels", label: "Channels", icon: "HashtagIcon" },
        { id: "search",   label: "Search",   icon: "MagnifyingGlassIcon" },
        { id: "profile",  label: "Profile",  icon: "UserCircleIcon" },
    ];

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-app-surface/95 backdrop-blur-md border-t border-border-subtle shadow-[0_-4px_24px_rgba(0,0,0,0.15)]">
            <div className="flex items-center justify-around px-2 py-2">
                {navItems.map((item) => {
                    const isActive = activeView === item.id && item.id !== "search";
                    return (
                        <button
                            key={item.id}
                            onClick={() => {
                                if (item.id === "search") {
                                    onSearchOpen?.();
                                } else {
                                    onViewChange?.(item.id);
                                }
                            }}
                            className={`flex flex-col items-center gap-1 px-4 py-2 rounded-2xl relative min-w-[60px] transition-all duration-200 ${
                                isActive
                                    ? "text-primary -translate-y-0.5"
                                    : "text-text-muted"
                            }`}
                        >
                            {isActive && (
                                <span className="absolute inset-0 rounded-2xl bg-primary/10" />
                            )}
                            <AppIcon name={item.icon} size={20} />
                            <span className="text-[10px] font-bold uppercase tracking-wider relative">
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
